import React from "react";
import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Series,
  ValueAxis,
  Legend,
  Label,
  Tick,
  Title,
  Size,
  Font,
  Tooltip as DxTooltip
} from "devextreme-react/chart";
import { Tooltip } from "devextreme-react";




const dataSource = [
  { asset: "Asset 1", date: new Date("2024-11-17T00:00"), noMotion: 50, motion: 10 },
  { asset: "Asset 2", date: new Date("2024-11-17T00:00"), noMotion: 60, motion: 5 },
  { asset: "Asset 3", date: new Date("2024-11-17T00:00"), noMotion: 40, motion: 15 }
];


const TelemetryPanel = () => {
  return(
    <>
      <div style={{ padding: "10px" }}>
        <Chart
        dataSource={dataSource}
        rotated={true} // Horizontal bars
      >
        {/* X-Axis: Time */}
        <ArgumentAxis argumentType="datetime">
          <Label>
            <Font color="var(--app-text)" />
          </Label>
          <Tick color="var(--app-text)" />
        </ArgumentAxis>

        {/* Y-Axis: Assets */}
        <ValueAxis>
          <Label>
            <Font color="var(--app-text)" />
          </Label>
          <Tick color="var(--app-text)" />
        </ValueAxis>

        {/* No Motion series */}
        <Series
          valueField="noMotion"
          argumentField="date"
          name="No Motion"
          type="stackedBar"
          color="#B0B0B0"
        />

        {/* Motion series */}
        <Series
          valueField="motion"
          argumentField="date"
          name="Motion"
          type="stackedBar"
          color="#FFD54F"
        />

        <Legend verticalAlignment="bottom" horizontalAlignment="center">
          <Font color="var(--app-text)" />
        </Legend>
        <Tooltip enabled={true} />
      </Chart>
      </div>
    </>
  ) 
}  


export default TelemetryPanel;